import { getTemplateFiles } from '../templates';
import { authFetch } from '../services/api';

/**
 * Preload starter template files into a new project workspace.
 * Uses existing import-files API (no backend changes). Returns files for immediate editor state.
 */
/**
 * @param {{ strict?: boolean }} options — strict: throw if import fails (Use Template flow)
 */
export async function seedProjectTemplate(projectId, templateType, options = {}) {
  const { strict = false } = options;
  const files = getTemplateFiles(templateType);
  if (!files || Object.keys(files).length === 0) return null;

  try {
    const res = await authFetch(`/api/projects/${projectId}/import-files`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ files }),
    });
    if (res.ok) return files;
    const err = await res.json().catch(() => ({}));
    const message = err.detail || `Template import failed (${res.status})`;
    if (strict) throw new Error(message);
    console.warn('Template persist failed:', message);
  } catch (e) {
    if (strict) throw e;
    console.warn('Template persist failed:', e.message);
  }

  // Return files for local editor even if persist failed
  return files;
}
